module.exports = __webpack_public_path__ + "static/media/reading-list-empty.fb77650f.png";